import { render, staticRenderFns } from "./_decision.tab.vue?vue&type=template&id=1fd8916a&scoped=true"
import script from "./_decision.tab.vue?vue&type=script&lang=js"
export * from "./_decision.tab.vue?vue&type=script&lang=js"
import style0 from "./_decision.tab.vue?vue&type=style&index=0&id=1fd8916a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fd8916a",
  null
  
)

export default component.exports